import { render, staticRenderFns } from "./AdminAddExistingVessel.vue?vue&type=template&id=68d10b80&scoped=true"
import script from "./AdminAddExistingVessel.vue?vue&type=script&lang=js"
export * from "./AdminAddExistingVessel.vue?vue&type=script&lang=js"
import style0 from "./AdminAddExistingVessel.vue?vue&type=style&index=0&id=68d10b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d10b80",
  null
  
)

export default component.exports